import React from 'react';
import { View } from 'react-native';
import { PillButton } from '@cubemeet/ui';

export interface ChatPillWebProps {
  onPress: () => void;
  t?: (key: string) => string;
}

const ChatPillWeb: React.FC<ChatPillWebProps> = ({ onPress, t }) => {
  const text = (t && t('travelCard.actions.enterChat')) || 'Chat';
  return (
    <View>
      <PillButton iconName="forum" text={text} onPress={onPress} />
    </View>
  );
};

export default ChatPillWeb;
